import { Outlet } from "react-router-dom";
import MoneySidebar from "../components/money/money-sidebar";

const MoneyWrapper = () => {
  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100 p-4 md:p-8 mx-auto justify-start gap-4">
      <div className="!w-80">
        <MoneySidebar />
      </div>
      {/* Main Content */}
      <Outlet />
    </div>
  );
};

export default MoneyWrapper;
